/**
 * author: Ananthapadmanabhan V K
 */
import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, OverlayTrigger } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import COMPANY_LOGO from "../../../src/images/logo.png";
import { UserContext } from "../../App";
import {
  SUBSCRIBER_ADMIN_TXT,
  SUPER_ADMIN_TXT,
  SUPPLIER_ADMIN_TXT,
} from "../../core/constants/api";
import { LS_AUTHORITY_KEY, LS_TERMS_AGREED_KEY, USER_ROLE } from "../../core/constants/common";
import { COMPLETED_TXT, ONBOARD_TXT } from "../../core/service/CommonService";
import SetPwdService from "../../core/service/SetPwdService";
import UserService from "../../core/service/UserService";
import LoginService from "../../core/service/login-service";
import Utils from "../../core/utilities/Utils";
import "./SetPassword.scss";
import PermissionUtils from "../../core/utilities/PermissisonUtils";
import { hasGoalsKpiNavAccess } from "../SubscriberSupplierAdmin/GoalsAndKpi/utils/goalsAndKpiNavAccess";
import { buildHierarchyPermissions } from "../SubscriberSupplierAdmin/GoalsAndKpi/utils/hierarchyPermissions";

const SetPassword = ({ t }) => {
  const [email, setEmail] = useState("");
  const password = useRef();
  const cPassword = useRef();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [cPasswordClass, setCPasswordClass] = useState("form-control");
  const [isCPasswordDirty, setIsCPasswordDirty] = useState(false);
  const { invite_key } = useParams();
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const resetKey = searchParams.get("key") ?? null;
  const resetEmail = searchParams.get("email") ?? null;
  const isUserPasswordReset =
    window.location.href.indexOf("reset_password") >= 0;
  const isNew = searchParams.get("isNew") === "false" ? false : true;
  const { setUserDetails } = useContext(UserContext);

  // var dummyKey = '7E0NhEvjHsfpqam8xo0L';
  useEffect(() => {
    if (isUserPasswordReset) {
      setEmail(resetEmail ?? "");
    } else {
      verifyInvitation(invite_key);
    }
  });

  const verifyInvitation = (key) => {
    SetPwdService.verifyInvitation(key)
      .then((response) => {
        setEmail(response.data.email);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (isCPasswordDirty) {
      if (password.current.value === cPassword.current.value) {
        setShowErrorMessage(false);
        // setCPasswordClass('form-control is-valid')
        setCPasswordClass("form-control");
      } else {
        setShowErrorMessage(true);
        setCPasswordClass("form-control is-invalid");
      }
    }
  }, [isCPasswordDirty]);

  const checkPasswords = (e) => {
    setIsCPasswordDirty(true);
    if (isCPasswordDirty) {
      if (password.current.value === cPassword.current.value) {
        setShowErrorMessage(false);
        // setCPasswordClass('form-control is-valid')
        setCPasswordClass("form-control");
      } else {
        setShowErrorMessage(true);
        setCPasswordClass("form-control is-invalid");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    setValidated(true);
    if (form.checkValidity() === false) {
      e.stopPropagation();
      return;
    }

    if (isUserPasswordReset) {
      UserService.finishPasswordReset({
        key: resetKey,
        newPassword: password.current.value,
      })
        .then((res) => {
          toast.success(t("UserPasswordResetSuccess.message"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: true,
          });
          navigate("/login");
        })
        .catch((error) => {
        });
    } else {
      const obj = {
        key: invite_key,
        newPassword: password.current.value,
      };
      SetPwdService.createPassword(obj)
        .then((response) => {
          if (response.status === 200) {
            localStorage.setItem("accessToken", response.data.data.accessToken);
            checkLoginAuthority();
          }
        })
        .catch((error) => {
          // console.log('error', error);
          // toast.error(error.message, {
          //   position: toast.POSITION.TOP_RIGHT,
          // });
        });
    }
  };

  const checkLoginAuthority = async (e) => {
    LoginService.checkAuthority()
      .then((response) => {
        var responseData = response.data.data;
        setUserDetails(responseData);
        if (response.status === 200) {
          localStorage.setItem("authority", JSON.stringify(responseData));
          localStorage.setItem(LS_TERMS_AGREED_KEY, responseData?.profile?.user?.termsAgreed ?? true);
         // if (responseData.roles.indexOf(SUPER_ADMIN_TXT) > -1) {
          if(PermissionUtils.isSuperAdmin(responseData.roles)) {
            navigate("/admin/");
          } else {
            if (responseData && responseData.profile.company) {
              profileCompletion(responseData.profile.company.id);
            } else {
              profileCompletion(0);
            }
          }
        }
      })
      .catch((error) => {
        // console.log('error', error);
        // toast.error(error.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      });
  };

  const profileCompletion = async (companyId) => {
    LoginService.profileComplete(companyId)
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem(
            "userOnboardData",
            JSON.stringify(response.data)
          );
          let lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
        //  if (lsDat.roles.indexOf(SUPER_ADMIN_TXT) > -1) {
        if(PermissionUtils.isSuperAdmin(lsDat.roles)) {
            navigate("/admin/");
          } else {
            let nextStep = response.data.nextStep;
            // TEMPORARY: same Goals & KPI nav check as the sidebar. Land on Goals & KPI dashboard. Revisit soon.
            const companyLanding = hasGoalsKpiNavAccess(
              buildHierarchyPermissions(Array.isArray(lsDat?.roles) ? lsDat.roles : [])
            )
              ? "/company_admin/goals_kpi/dashboard"
              : "/company_admin/";
            switch (nextStep) {
              case null:
              case COMPLETED_TXT:
                navigate(companyLanding);
                break;
              case ONBOARD_TXT:
                navigate("/company_admin/company_onboard/" + response.data.key);
                break;
              default:
                navigate(companyLanding);
                break;
            }
            // navigate("/company_admin/");
          }
        }
      })
      .catch((error) => {
        console.log("error", error);

        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <section className="Set_Pwd_page_section">
      <div className="row m-0">
        <div className="col-lg-6 col-md-6 p-0 Set_Pwd_leftBox">
          <div className="Set_Pwd_leftBox_Logo">
            <img src={COMPANY_LOGO} />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 p-0 Set_Pwd_RightBox">
          <div className="Set_Pwd_Form">
            <div className="Set_Pwd_Form_in">
              <div className="mb-4 Set_Pwd_Form_in_head">
                <h2>
                  {isNew === false
                    ? t("ResetPassword.label")
                    : t("welcomeSetPwd.label")}
                </h2>
              </div>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className="mb-4">
                  <div className="mb-3">
                    <label className="mb-1">{t("Emailid.label")}</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      autoComplete="off"
                      readOnly
                      value={email}
                      required
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password1"  className="mb-1">
                      {t("password.label")}
                    </label>
                    <OverlayTrigger
                      placement="bottom"
                      overlay={Utils.renderTooltip(
                        <div className="OverlayList text-left">
                          <h6> {t("PasswordCriteria.label")}</h6>
                          <ul className="list-inline">
                            <li>{t("containalphabet.label")}</li>
                            <li>{t("containdigital.label")}</li>
                            <li>{t("containspecial.label")}</li>
                            <li>{t("seqencecharater.label")}</li>
                          </ul>
                        </div>
                      )}
                    >
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        ref={password}
                        placeholder={t("EnterPassword.label")}
                        onChange={checkPasswords}
                        autoComplete="off"
                        required
                      />
                    </OverlayTrigger>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="confirmPassword"  className="mb-1">
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      className={cPasswordClass}
                      id="confirmPassword"
                      ref={cPassword}
                      placeholder={t("ReEnterPassword.label")}
                      onChange={checkPasswords}
                      autoComplete="off"
                      required
                    />
                    {showErrorMessage && isCPasswordDirty ? (
                      <div className="Confirm_Pwd_Error">
                        {" "}
                        {t("PasswordMismatch.label")}{" "}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {isNew === true && (
                    <div className="pb-2 form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="iagreecheck"
                        required
                      />
                      <label className="form-check-label" htmlFor="iagreecheck">
                        {t("IAgree.label")}{" "}
                        <a href="#">{t("termsServices.label")}</a>{" "}
                        {t("and.label")}
                        <a href="#"> {t("privacyPolicy.label")}</a>
                      </label>
                    </div>
                  )}
                  {isNew === false && (
                    <div className="form-check">
                      <a className="Forgot_pass" href="/login">
                        {t("Backtologin.label")}
                      </a>
                    </div>
                  )}
                </div>
                <button type="submit" className="btn btn-primary w-100 sbmBtn">
                  {isNew ? t("continue.label") : t("submit.label")}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withTranslation()(SetPassword);
